import logo from "../../asset/img/logo-cetelem.png"
import logoEvollis from "../../asset/img/retail_pt/evollis_logo.png"
import { TENANTS } from "../../constants"
import { loc } from "../../core/utils"
import { withTunnelDataContext } from "../../digital-journey/hoc/withTunnelDataContext"
import TextField from "../../form/TextField"
import { isUserConnected, login } from "../../service/authorization"
import "./styles.css"
import React from "react"
import { Form } from "react-bootstrap"
import { Button } from "react-bootstrap"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import * as FinalForm from "react-final-form"
import { useMutation } from "react-query"

const onValidate = (values) => {
  const errors = {}
  if (!values.username) {
    errors.username = loc("Required")
  }
  if (!values.password) {
    errors.password = loc("Required")
  }
  return errors
}

const LoginPage = ({ tunnelData, onSetStep, history }) => {
  const { error, mutate } = useMutation(login, {
    mutationKey: "login-user",
    retry: false,
    onSuccess: (data) => {
      if (isUserConnected()) {
        onSetStep()
      }
    },
    onError: (error) => {
      console.error(error)
      if (error.error_description === "User credentials have expired") {
        history.push({
          pathname: "/reset-password",
          state: {
            userName: error?.username
          }
        })
      }
    }
  })

  const onSubmit = (values) => {
    const { username, password } = values
    mutate({ username, password, tunnelData })
  }

  return (
    !isUserConnected() && (
      <div className="div-center">
        <div className="login-form hard-shadow-white-block">
          {[TENANTS.RETAIL_FNAC_PT, TENANTS.RETAIL_IT].includes(tunnelData.tenant) ? (
            <img src={logoEvollis} className="logo" alt="brand logo" />
          ) : (
            <img src={logo} className="logo" alt="brand logo" />
          )}
          <FinalForm.Form
            validate={onValidate}
            onSubmit={onSubmit}
            render={({ handleSubmit }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  {error?.error_description && <p className="error-message">{loc(error?.error_description)}</p>}
                  <TextField name="username" label={loc("username")} />
                  <TextField name="password" label={loc("password")} type="password" />
                  <Button variant="success" className="submit" type="submit">
                    {loc("connect")}
                  </Button>

                  <div className="div-tooltip">
                    <OverlayTrigger
                      placement={"right"}
                      overlay={<Tooltip>{loc("login page need help tooltip")}</Tooltip>}
                    >
                      <p className="help-message">{loc("need help")}</p>
                    </OverlayTrigger>
                  </div>
                </Form>
              )
            }}
          />
        </div>
      </div>
    )
  )
}

export default withTunnelDataContext(LoginPage)
